(() => {
	const toNumber = (value, fallback) => {
		const num = Number(value);
		return Number.isFinite(num) && num > 0 ? num : fallback;
	};

	const getSlidesPerView = (columnCount, max) => Math.min(columnCount, max);

	const initSlider = (section) => {
		let collectionsSlider;

		if (document.currentScript) {
			collectionsSlider = document.currentScript.parentElement.querySelectorAll(
				".js-slider-collections-slider"
			);
		} else {
			collectionsSlider = section.querySelectorAll(
				".js-slider-collections-slider"
			);
		}

		if (!collectionsSlider || collectionsSlider.length === 0) return;

		collectionsSlider.forEach((el) => {
			if (el.swiper) return;

			const speed1 = toNumber(el.getAttribute("data-duration"), 1000);
			const columnCount = toNumber(el.getAttribute("data-column-count"), 4);
			const mobileColumns = toNumber(el.getAttribute("data-columns-mobile"), 1);
			const prevBtn = section.querySelector(".swiper-button-prev");
			const nextBtn = section.querySelector(".swiper-button-next");

			new Swiper(el, {
				slidesPerView: getSlidesPerView(columnCount, mobileColumns),
				spaceBetween: 20,
				autoplay: false,
				direction: "horizontal",
				loop: false,
				speed: speed1,
				shortSwipes: true,
				longSwipes: true,
				allowTouchMove: true,
				watchOverflow: true,
				navigation:
					prevBtn && nextBtn ? { nextEl: nextBtn, prevEl: prevBtn } : false,
				breakpoints: {
					576: {
						slidesPerView: getSlidesPerView(columnCount, 2),
						spaceBetween: 20,
					},
					750: {
						slidesPerView: getSlidesPerView(columnCount, 2),
						spaceBetween: 20,
					},
					990: {
						slidesPerView: getSlidesPerView(columnCount, 3),
						spaceBetween: 20,
					},
					1150: {
						slidesPerView: getSlidesPerView(columnCount, columnCount),
						spaceBetween: 20,
					},
					1360: {
						slidesPerView: getSlidesPerView(columnCount, columnCount),
						spaceBetween: 20,
					},
				},
				mousewheel: {
					forceToAxis: true,
				},
			});
		});
	};

	const initSection = (section) => {
		let sectionCollections;

		if (document.currentScript) {
			sectionCollections = document.currentScript.parentElement;
		} else {
			sectionCollections = section;
		}

		if (!sectionCollections) return;

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			const sliders = entry.target.querySelectorAll(
				".js-slider-collections-slider"
			);

			sliders.forEach((slider) => {
				if (slider.swiper) slider.swiper.destroy(true, true);
			});

			initSlider(sectionCollections);
		});

		initSlider(sectionCollections);
		sectionResizeObserver.observe(sectionCollections);
	};

	initSection();

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();
